import { motion } from "framer-motion";
import { BookOpen, NotebookPen, PencilRuler, SpellCheck, Trophy } from "lucide-react";

const LESSONS = [
    {
        icon: BookOpen,
        title: "Reading & Comprehension",
        text: "Practise fluency, vocabulary, finding key details, understanding meaning and answering questions with confidence.",
    },
    {
        icon: PencilRuler,
        title: "Grammar & Punctuation",
        text: "Strengthen sentence structure, parts of speech and punctuation so your child's writing becomes clear and correct.",
    },
    {
        icon: SpellCheck,
        title: "Spelling & Vocabulary",
        text: "Build strong spelling patterns and a richer, more useful vocabulary for reading and writing.",
    },
    {
        icon: NotebookPen,
        title: "Creative & Structured Writing",
        text: "Develop sentences, paragraphs, recounts, narratives and descriptions — from imaginative stories to well-structured writing.",
    },
    {
        icon: Trophy,
        title: "Building English Confidence",
        text: "Gentle encouragement and regular practice help children read, write and speak English with growing confidence.",
    },
];

export const Classes = () => (
    <section id="lessons" className="mx-auto max-w-7xl scroll-mt-24 px-6 py-20 lg:py-28" data-testid="lessons-section">
        <motion.div
            className="max-w-2xl"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
        >
            <p className="text-xs font-bold tracking-widest text-sun uppercase">Lessons and learning support</p>
            <h2 className="font-heading mt-3 text-3xl font-extrabold tracking-tight text-ink sm:text-4xl">
                English skills for every learning step
            </h2>
            <p className="mt-4 text-base text-mist sm:text-lg">
                Every lesson is personalised to your child's grade, current ability and school curriculum, so the
                support always matches what they are learning at school.
            </p>
        </motion.div>
        <div className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {LESSONS.map((item, i) => (
                <motion.div
                    key={item.title}
                    data-testid={`lesson-card-${i + 1}`}
                    className="group rounded-3xl border border-ground-line/70 bg-ground-soft/50 p-8 transition-all duration-300 hover:-translate-y-1 hover:border-sun/50 hover:shadow-xl hover:shadow-black/30"
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.55, delay: i * 0.1 }}
                >
                    <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-sun text-ground-deep shadow-lg shadow-sun/20 transition-transform duration-300 group-hover:scale-110">
                        <item.icon className="h-7 w-7" strokeWidth={2} />
                    </span>
                    <h3 className="font-heading mt-6 text-xl font-bold text-ink">{item.title}</h3>
                    <p className="mt-3 text-sm leading-relaxed text-mist">{item.text}</p>
                </motion.div>
            ))}
        </div>
    </section>
);
